<template>
  <section
    :id="module.id"
    class="categories-wrapper"
    :style="[categoriesWrapperElStyles]"
  >
    <GlobalUIMedia
      v-if="module.config.general.showMedia"
      :media="module.config.general.media"
      :lazy="lazy"
    />
    <div class="inner-wrapper" :style="[modulePadding]">
      <component
        :is="module.config.general.template.component"
        :module="module"
        :job-counts="jobCounts"
        :zero-jobs-text="zeroJobsText"
        @emitted-click="(child) => $emit('emittedClick', { module, child })"
      />
    </div>
  </section>
</template>

<script>
import categoriesModule from "./categoriesDefaultModuleProp.js";
import CategoriesTower from "./Templates/CategoriesTower.vue";
import CategoriesStack from "./Templates/CategoriesStack.vue";
import CategoriesRibbon from "./Templates/CategoriesRibbon.vue";
import CategoriesPuzzle from "./Templates/CategoriesPuzzle.vue";
import CategoriesPyramide from "./Templates/CategoriesPyramide.vue";

import { globalComputed, globalMethods } from "../GlobalUI/mixins/global.js";
import GlobalUIMedia from "../GlobalUI/GlobalUIMedia.vue";

export default {
  components: {
    GlobalUIMedia,
    CategoriesTower,
    CategoriesStack,
    CategoriesRibbon,
    CategoriesPyramide,
    CategoriesPuzzle,
  },
  name: "Categories",
  mixins: [globalComputed, globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return categoriesModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    jobCounts: {
      type: Array,
      default() {
        return [];
      },
    },
    zeroJobsText: {
      type: String,
      default: "",
    },
  },
  computed: {
    categoriesWrapperElStyles() {
      const { backgroundColor, textColor } = this.module.config.general;

      return {
        backgroundColor: backgroundColor.value,
        "--categories-border-color": textColor.value,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.categories-wrapper {
  container-type: inline-size;
  contain: layout;
  display: flex;
  place-content: center;
}

.inner-wrapper {
  flex-grow: 1;
  max-width: 1600px;
  margin: 0;
  margin-inline: var(--cr-spacing-l);

  @include tablet {
    margin-inline: var(--cr-spacing-m);
  }

  @include mobile {
    margin-inline: var(--cr-spacing-xs);
  }
}
</style>
